<template>
  <!-- <CardExibirPDF 
      v-if="pdfElement" 
      v-model="exibirPDF" 
      :nomeDocumento='nomeDocumentoPDF' 
      :tituloTela="titulo" 
      :position="'top'" 
      :tamanhoTela="'55.em'"  
      :alturaTela="'55.em'" 
      :pdfElement="pdfElement"
     /> -->
  <div style="height: 100vh">
    <embed
      style="width: 100%; height: 100%"
      :src="stringPDF"
      v-if="exibirPDF"
    />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import { baseApiUrlCertidao } from "@/config/global";

export default defineComponent({
  components: { CardExibirPDF },
  data() {
    return {
      nomeDocumentoPDF: "Vinculo Servidor",
      exibirPDF: false,
      stringPDF: "data:application/pdf;base64,",
    };
  },
  created() {
    let { cpf, chave } = this.$route.params;
    this.$http
      .get(`${baseApiUrlCertidao}/publicos/validarcertidao/${chave}/${cpf}`)
      .then((res) => {
        this.nomeDocumentoPDF = res.data.nomeArquivo;
        this.stringPDF += res.data.dadosRelatorioBase64;
        this.exibirPDF = true;
      });
  },
});
</script>
